<template>
  <div class="px-5 pb-5" style="height: 100%; overflow: auto">
    <div>
      <v-alert
        v-if="command.status === 'connect'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        class="mt-2"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        class="mt-2"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <p>พนักงาน ( ทั้งหมด {{ command.responseData.length }} คน )</p>
        <v-list-item
          class="pa-0 mb-2"
          v-for="item in command.responseData"
          :key="item.fid"
        >
          <v-list-item-content class="grey lighten-3 pl-4">
            <v-list-item-title> รหัสพนักงาน: {{ item.fid }} </v-list-item-title>
            <v-list-item-subtitle v-if="item['Last Updated']">
              อัพเดทล่าสุด: {{ item['Last Updated'] | dateTimeFormat }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
              อัพเดทล่าสุด: -
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div v-if="command.status === 'fail'">
        <v-list-item
          two-line
          v-for="(value, key) in command.responseData"
          :key="key"
        >
          <v-list-item-content>
            <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
            <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
              {{ value }}
            </p>
          </v-list-item-content>
        </v-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      syncJobId: null,
    }
  },

  filters: {
    dateTimeFormat: function (value) {
      return moment.utc(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },

  mounted() {
    const { company_uuid } = this.$store.state.authentication.company

    const payload = {
      company_uuid,
      hardware_model: this.hardware.hardware_model.hardware_model_code,
      body: {
        hardware_uuid: this.hardware.hardware_uuid,
        data: null,
      },
    }

    this.getEmployeeList(payload)
      .then((res) => {
        this.command = {
          status: 'connect',
          date: res.create_datetime,
        }
        this.syncJob(res.sync_job_uuid)
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          this.command = {
            status: 'fail',
            date: new Date(),
            responseData: {
              Type: 'Get Employees Fail',
              Message: error.response.data.message || 'Error',
            },
          }
        }
      })
  },

  methods: {
    ...mapActions({
      getEmployeeList: 'hardware/getEmployeeList',
      fetchJob: 'hardware/fetchJob',
      userAcknowledge: 'hardware/userAcknowledge',
    }),

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        let responseData
        if (
          res.response_json.length > 0 &&
          res.response_json[0]['Last Updated'] === undefined
        ) {
          responseData = res.response_json
            .map((item) => ({ fid: item, ['Last Updated']: null }))
            .sort((a, b) => a.fid.localeCompare(b.fid))
        } else {
          responseData = res.response_json.sort((a, b) =>
            a.fid.localeCompare(b.fid)
          )
        }
        this.command = {
          status: 'success',
          date: res.done_datetime,
          responseData,
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.done_datetime && !res.is_response_success) {
        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
